import { connect } from 'react-redux'
import compose from 'recompose/compose'
import withProps from 'recompose/withProps'

import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as ClassificationSelectors from 'app/modules/classification/selectors'
import { isLeadBotPlaybook } from 'app/modules/playbook/constants.js'

import PlaybookConversationEvent from './component'

const mapStateToProps = (state, props) => {
  const goals = PlaybookSelectors.allGoals(state)
  return {
    playbook: PlaybookSelectors.getPlaybook(state, props),
    classifications: ClassificationSelectors.classifications(state),
    goal: goals.find(goal => goal.get('id') === props.goalId)
  }
}

export default compose(
  connect(mapStateToProps),
  withProps(props => ({
    loaded: !!props.playbook && !!props.goal,
    isLeadBotPlaybook: isLeadBotPlaybook(props.playbook.reportType)
  }))
)(PlaybookConversationEvent)



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/PlaybookConversationEvent/index.js